import type { ClueProblem } from '../types';
import { MAX_CLUE_LENGTH } from './constants';

/** Нижний регистр, ё → е, без пробелов по краям. */
export const norm = (s: string): string => String(s).toLowerCase().replace(/ё/g, 'е').trim();

/** Ровно одно слово (допускается один дефис): без пробелов, цифр и знаков. */
export const isOneWord = (s: string): boolean => /^[a-zа-яё]+(-[a-zа-яё]+)?$/i.test(String(s).trim());

/** Грубая «основа» слова: отрезаем окончание. Эвристика, а не морфология. */
export function stem(word: string): string {
  const w = norm(word);
  if (w.length > 5) return w.slice(0, w.length - 2);
  if (w.length === 5) return w.slice(0, 4);
  if (w.length === 4 && /[аеиоуыэюяйь]$/.test(w)) return w.slice(0, 3);
  return w;
}

/**
 * Однокоренные ли слова (эвристика). Возможны ложные срабатывания на коротких словах (tea/team)
 * и пропуски (волк/волчий) — пропуски страхует ИИ-судья в запросе к Jev.
 */
export function sameRoot(a: string, b: string): boolean {
  const x = norm(a);
  const y = norm(b);
  if (x === y) return true;
  if (x.length >= 3 && y.includes(x)) return true;
  if (y.length >= 3 && x.includes(y)) return true;
  const sx = stem(x);
  const sy = stem(y);
  if (sx.length >= 3 && y.startsWith(sx)) return true;
  if (sy.length >= 3 && x.startsWith(sy)) return true;
  if (sx.length >= 4 && y.includes(sx)) return true;
  if (sy.length >= 4 && x.includes(sy)) return true;
  return false;
}

/** Локальная проверка подсказки (шаг 1 из 3, см. AGENTS.md 4.3). null — подсказка допустима. */
export function clueProblem(words: readonly string[], clue: string): ClueProblem | null {
  if (!clue) return { code: 'empty' };
  if (clue.length > MAX_CLUE_LENGTH || !isOneWord(clue)) return { code: 'not_one_word' };
  for (const w of words) if (sameRoot(clue, w)) return { code: 'same_root', word: w };
  return null;
}
